<template>
  <div v-if="activity" class="activity-card" @click="onClick(activity)">
    <div v-if="selected">
      <!-- class small-load-spinner is used to adjust the size of the loadspinner to fit the ActivityCard  -->
      <LoadSpinner :color="`#${organizationDetails.darkBrandColor}`" />
    </div>
    <template v-else>
      <div class="fcolumn" :class="{ mobile: !forceMobile }">
        <div class="form-field frow">
          <div class="form-field-container">
            <div class="field-name" v-translate>Amount</div>
            <div class="field-value">{{ activity.request.amount | currency }}</div>
          </div>
          <div class="form-field-container">
            <div class="field-name">{{ $gettext('Status:') }}</div>
            <div class="field-value">
              <translate>{{ activity.request.statusDisplay }}</translate>
              <span v-if="isPartiallyApproved"
                >&nbsp;({{ activity.request.approvedFunds | currency }})</span
              >
            </div>
          </div>
        </div>
        <div class="form-field frow">
          <div class="form-field-container">
            <div class="field-name" v-translate>Date</div>
            <div class="field-value">
              {{ this.activity.datetimeCreated | formatDateShort($language.current) }}
            </div>
          </div>
        </div>
      </div>

      <div v-if="!forceMobile" class="hidden-mobile">
        <div class="frow tablet-desktop-activity" style="justify-content: space-between;">
          <div>{{ activity.request.amount | currency }}</div>
          <div>
            <translate>{{ activity.request.statusDisplay }}</translate>
            <span v-if="isPartiallyApproved"
              >&nbsp;({{ activity.request.approvedFunds | currency }})</span
            >
          </div>
          <div>
            {{ this.activity.datetimeCreated | formatDateShort($language.current) }}
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import LoadSpinner from '@/components/LoadSpinner'
import { mapState } from 'vuex'
import Request from '@/services/requests'
export default {
  name: 'ActivityCard',
  components: {
    LoadSpinner,
  },
  data() {
    return {
      selected: false,
    }
  },
  props: {
    activity: {
      type: Object,
      required: true,
    },
    forceMobile: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getScopedOrgProperty(propName) {
      // Empty strings and zero are considered null/undefined/not-set
      const orgValue = this.organizationDetails && this.organizationDetails[propName]
      const subOrgValue = this.user.subOrganizationRef && this.user.subOrganizationRef[propName]

      return subOrgValue || orgValue
    },
    maxedGrantLimit() {
      const amountLimit = this.getScopedOrgProperty('grantLimit')
      const countLimit = this.getScopedOrgProperty('grantCountLimit')

      const hasLimits = amountLimit || countLimit

      if (!hasLimits) { return false }

      const currentAmount = this.user.totalPayoutsSinceLastGrantLimitReset
      const currentCount = this.user.totalNumberPayoutsSinceLastGrantLimitReset

      const overAmount = currentAmount >= amountLimit
      const overCount = currentCount >= countLimit

      return overAmount || overCount
    },
    async onClick(action) {
      this.selected = true
      request: if (action.request) {
        const request = await Request.api.retrieve(action.request.id)
        this.$store.dispatch('updateCurrentRequest', request)

        if (request.status === Request.options.STARTED && this.maxedGrantLimit()) {
          this.$router.push({ name: 'NewRequest' })
          break request
        }

        if (request.isReproductiveRightsRequest) {
          this.$router.push({ name: await this.nextRoute('PayPalVerify') })
          break request
        }

        if (request.status === Request.options.STARTED) {
          this.$router.push({ name: await this.nextRoute('PayPalVerify') })
          break request
        }

        this.$router.push({ name: 'RequestSummary' })
      } else if (action.donation) {
        this.$router.push({
          name: 'DonationSummary',
          params: { id: action.donation.id },
        })
      }
    },
    async nextRoute(noSurveysRoute) {
      return noSurveysRoute
    },
  },
  computed: {
    ...mapState(['user', 'organizationDetails']),
    isPartiallyApproved() {
      return this.activity.request.status == Request.options.PARTIALLY_APPROVED
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixins/buttons';
@import '@/styles/mixins/containers';
@import '@/styles/flex-box';

.activity-card {
  cursor: pointer;
  padding: 1rem 0.5rem;

  &:hover {
    background-color: #f0f0f0;
  }
}

.form-field {
  padding: 0;
  margin-bottom: 1rem;

  .form-field-container {
    flex: 1;
  }

  &:last-of-type {
    margin-bottom: 0rem;
  }
}

.tablet-desktop-activity {
  div:nth-child(1) {
    width: 15%;
  }

  div:nth-child(2) {
    width: 35%;
  }

  div:nth-child(3) {
    width: 20%;
  }
}
</style>
